import Rails from "@rails/ujs"

import $ from "./jquery_global"

// このプロジェクトでは Select2 を
//   $(".js-select2").select2()
// のように jQuery プラグインとして利用しています。
//
// ESM / bundler（esbuild 等）環境では、jQuery は必ずしも
// グローバル（window.$）ではありません。
// そのため `import "select2"` だけだと jQuery に登録されず、
//   $(...).select2 is not a function
// になることがあります。
//
// Webpacker 時代は jQuery をグローバルに公開する設定が一般的で、
// Select2 が自動で同じ jQuery に登録できていました。
//
// ここでは Select2 の初期化関数を明示的に呼び出し、
// Select2 を「このプロジェクトで使っている jQuery インスタンス」に
// jQuery プラグインとして確実に登録しています。
import initSelect2 from "select2"
initSelect2(globalThis, $)

import './shared/i18n'

import 'bxslider/dist/jquery.bxslider.min.js'

import { SETTINGS } from './mypage/js/drupal_settings'

import './mypage/js/jquery.once'
import './mypage/js/drupal'
import './mypage/js/jquery.form'
import './mypage/js/jquery-extend-3.4.0'
import './mypage/js/jquery-html-prefilter-3.5.0-backport'
import './mypage/js/jquery.sumoselect'
import './mypage/js/ajax'
import './mypage/js/progress'
import './mypage/js/skill'
import './mypage/js/yubinbango-ex'
import './mypage/js/jp_location_entities'
import './mypage/js/profile'
import "./mypage/js/profile_supplement";
import './mypage/js/favorite'
import './mypage/js/modal'
import './mypage/js/tab'
import './mypage/js/job_search'
import './mypage/js/custom'
import './mypage/js/auto-submit'
import './mypage/js/view_save'
import './mypage/js/notify_modal'
import './mypage/js/jquery.jcarousel'

$.extend(Drupal.settings, SETTINGS)

import './mypage/js/form'
import './mypage/js/collapse'
import './mypage/js/account'
import './mypage/js/back_to_top'
import './mypage/js/jquery.meanmenu'
import './mypage/js/body_scroll_lock'
import './mypage/js/responsive_menus_mean_menu'
import './mypage/js/maxlength'
import './shared/career'
import './shared/open_new_tab'
import './mypage/js/jcarousel'
import './mypage/js/header'

// Drupal.behaviors.collapse

Rails.start()

$(function() {
  $('.bxslider').bxSlider({
    auto: true,
    pager: false
  });
  if (location.pathname != '/') {
    $('#block-menu-menu-footer-menu li.leaf a[href^="' + location.pathname + '"]').addClass('active');
  }
});
